import { SET_ANNOUNCEMENT_STATE } from 'redux/actions/types' // eslint-disable-line
const defaultState = {
  announcementModalVisible: false,
  modalState: 'chooseRecipients',
  includeOwners: false,
  includeTenants: false,
  missingEmails: [],
  primaryArray: [],
  copyFunction: false,
  isRental: false,
  setContactsInToField: false,
  specificContacts: '',
}

const announcementState = (state = defaultState, action) => {
  const { type, payload } = action
  switch (type) {
    case SET_ANNOUNCEMENT_STATE:
      return { ...state, ...payload }
    default:
      return state
  }
}
export default announcementState
